; (function ($) {

    if (!$("body").hasClass("post-type-archive-3226_corporate")) return;

    $('.single-corporate .show-all, .single-corporate .hero').on('click', function(e) {
        e.preventDefault(); 
        e.stopPropagation();

        
        if (!$(this).parent().hasClass('active')) {
            $(this).parent().addClass('transitioning');
            
            setTimeout(() => {
                $(this).parent().removeClass('transitioning');
                $(this).parent().addClass('active');
                
                let parentTop = $(this).parent().offset().top - 50;
                $('html, body').animate({
                    scrollTop: parentTop
                })
            }, 400);
        } else {
            $(this).parent().removeClass('active');
        }
        
        $('.single-corporate.active').removeClass('active');
        
    });

    function initSlides(slides, slideshow) {
        console.log('initSlides');
        if (slides.length > 1)
            setInterval(function () {
                nextSlide(slideshow);
            }, 4000);
        else
            return false;
    }

    function nextSlide(slideshow) {
        let slideCount = ($(`#${slideshow} .slide`).toArray()).length - 1;
        let currentSlide = Number($(`#${slideshow} .slide.active`).attr('data-slide'));
        $(`#${slideshow} .slide.active`).removeClass('active');
        if (currentSlide == slideCount) {
            currentSlide = 0;
        } else {
            currentSlide++;
        }
        $(`#${slideshow} .slide[data-slide="${currentSlide}`).addClass('active');

    }

    $(document).ready(function () {
        let slideshows = $('.slideshow').toArray();
        if (slideshows.length > 0) {
            slideshows.map((slideshow) => {
                let slideshowId = $(slideshow).attr('id');
                let slides = $(`#${slideshowId} .slide`).toArray();
                initSlides(slides, slideshowId);
            });
        }
        
    });

})(jQuery);